var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1673 6.87747C10.1673 6.08105 9.52686 5.572 8.48412 5.572C7.98328 5.572 7.32644 5.74442 6.9816 5.97432L7.04728 6.85284C7.45781 6.55726 7.9997 6.40126 8.42665 6.40126C8.91107 6.40126 9.18202 6.5901 9.18202 6.91853C9.18202 7.62463 7.2197 7.59179 7.2197 8.79053C7.2197 9.45558 7.74518 9.88253 8.57444 9.88253C8.88644 9.88253 9.18202 9.83326 9.39549 9.77579L9.26412 9.05326C9.08349 9.11895 8.86181 9.15179 8.68118 9.15179C8.34455 9.15179 8.16391 9.02042 8.16391 8.77411C8.16391 8.12547 10.1673 8.14189 10.1673 6.87747ZM8.86181 11.0074C8.86181 10.6789 8.60728 10.4244 8.25423 10.4244C7.88476 10.4244 7.62202 10.6872 7.62202 11.0566C7.62202 11.3768 7.86833 11.6478 8.2296 11.6478C8.59907 11.6478 8.86181 11.3686 8.86181 11.0074Z",
    fill: "#0D8ECA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.342105,
    y: 0.342105,
    width: 16.3158,
    height: 16.3158,
    rx: 8.1579,
    stroke: "#0D8ECA",
    strokeWidth: 0.684211
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSectors);
export default __webpack_public_path__ + "static/media/info-sectors.5212f875906ff8fa97abea83b79c06fb.svg";
export { ForwardRef as ReactComponent };